import React, { Fragment, useEffect, useState } from "react";
import { useStyletron } from "baseui";
import { FormControl } from "baseui/form-control";
import { Input, StyledInput, SIZE as INPUT_SIZES } from "baseui/input";
import { styled } from "styletron-react";
import { Textarea, SIZE as TEXT_SIZE } from "baseui/textarea";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import TagInput from "../tag-input/TagInput";
const InputDiv = styled(FlexGridItem, {
  // margin: "5px",
});

export default function MultioptionInputTemplate({
  handleItemPropsChanged,
  ...props
}) {
  const [name, setName] = useState(props.name);
  const [displayName, setDisplayName] = useState(props.displayName);
  const [defaultValue, setDefaultValue] = useState(
    props.defaultValue === "" ? "Default" : props.defaultValue
  );
  const [optionsList, setOptionsList] = useState(
    props.optionsList?.length ? props.optionsList : ["Default"]
  );
  const [description, setDescription] = useState(props.description);
  const [, setExpanded] = React.useState(props.isSelected);
  const [css] = useStyletron();
  const [error, setError] = useState({...props.errors["common"], ...props.errors["multioption"]});

  useEffect(() => {
    setExpanded(props.isSelected);
  }, [props.isSelected]);

  useEffect(() => {
    setExpanded(props.isSelected);
    setName(props.name);
    setDisplayName(props.displayName);
    setDefaultValue(props.defaultValue === "" ? "Default" : props.defaultValue);
    setOptionsList(props.optionsList);
    setDescription(props.description);
  }, [
    props.isSelected,
    props.name,
    props.displayName,
    props.defaultValue,
    props.optionsList,
    props.description,
  ]);

  useEffect(() => {
    setError({...props.errors["common"], ...props.errors["multioption"]});
  }, [props.errors]);

  function handleItemChange() {
      var item = {
        id: props.id,
        name: name,
        displayName: displayName,
        defaultValue: defaultValue,
        optionsList: optionsList,
        description: description,
      };
      handleItemPropsChanged(props.type, item);
  }
  return (
    <Fragment>
      <FlexGrid flexGridColumnCount={[1, 2, 2, 3]} flexGridColumnGap="scale400">
        <InputDiv>
          <FormControl
            label="Parameter name"
            caption={error.name ? "Parameter name should be alphanumeric and unique" : ""}
            error={error.name}
          >
            <Input
              type="text"
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setName(e.target.value)}
              value={name}
              size={INPUT_SIZES.compact}
              error={error.name}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl label="Display name">
            <Input
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setDisplayName(e.target.value)}
              value={displayName}
              size={INPUT_SIZES.compact}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl
            label="Default value"
            caption={
              error.defaultValue
                ? "Default value should be included in the options list."
                : ""
            }
            error={error.defaultValue}
          >
            <Input
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setDefaultValue(e.target.value)}
              value={defaultValue}
              size={INPUT_SIZES.compact}
              error={error.defaultValue}
            />
          </FormControl>
        </InputDiv>
      </FlexGrid>
      <div>
        <FormControl
          label="Options list"
          caption={error.optionsList ? "Options list should not be empty." : ""}
          error={error.defaultValue}
        >
          <TagInput
            disabled={!props.isSelected}
            onBlur={handleItemChange}
            onListChanged={setOptionsList}
            initialTags={optionsList}
            size={INPUT_SIZES.mini}
            error={error.optionsList}
          />
        </FormControl>
      </div>
      <div>
        <FormControl label="Description">
          <Textarea
            disabled={!props.isSelected}
            onBlur={handleItemChange}
            onChange={(e) => setDescription(e.target.value)}
            value={description || ""}
            size={TEXT_SIZE.mini}
            clearOnEscape
          />
        </FormControl>
      </div>
    </Fragment>
  );
}
